// SPEC-STORE-DAILY-REPORT-MODULE-01 (D-866): マネサポ「店舗」タブ(日報・月報)を直営店のアルバイトに
//   店単位で開くための ctx(current_staff_direct_stores() の結果)を 1 回だけ取るフック。
//   ★admin/manager/patrol/contractor は ROLE_VISIBLE_TABS 側で無条件に判定できるので、この結果を使わない
//     (使っても安全だが呼ぶだけ無駄。role !== 'staff' は RPC を叩かず空配列を即返す)。
//   ★D-866 gate_3 指摘 5: 取得失敗と「直営店が無い」を区別する。失敗しても storeCodes は空のまま
//     (fail-closed = 開けない)だが、error に理由を立て、retry() で取り直せるようにする。呼び出し側は
//     error のときに「権限なし」ではなく「読み込めなかった・再試行」を出す。
import { useCallback, useEffect, useState } from 'react'
import { supabase } from '../../lib/supabase'
import { logger } from '../../lib/logger'

const IDLE = { storeCodes: [], loading: false, error: null }

export function useDirectOperatedStores(role) {
  const [state, setState] = useState(() => ({ storeCodes: [], loading: role === 'staff', error: null }))
  const [attempt, setAttempt] = useState(0)
  const retry = useCallback(() => setAttempt(n => n + 1), [])

  useEffect(() => {
    if (role !== 'staff') {
      setState(IDLE)
      return
    }
    let cancelled = false
    setState({ storeCodes: [], loading: true, error: null })
    // ★supabase の簡易モック(rpc を持たない)で通す既存テストを壊さないよう、呼べないときは
    //   同期例外で落とさず空配列に倒す(本番の supabase-js は常に rpc を持つので実挙動には影響しない)。
    if (typeof supabase?.rpc !== 'function') {
      setState(IDLE)
      return () => { cancelled = true }
    }
    const fail = (message) => {
      if (cancelled) return
      logger.warn?.('ERR-DIRECT-STORES-FETCH', { message })
      setState({ storeCodes: [], loading: false, error: message || 'fetch_failed' })
    }
    supabase.rpc('current_staff_direct_stores')
      .then(({ data, error }) => {
        if (cancelled) return
        if (error) return fail(error.message)
        if (!Array.isArray(data)) return fail('invalid_response')
        setState({ storeCodes: data, loading: false, error: null })
      })
      .catch(e => fail(e?.message ?? String(e)))
    return () => { cancelled = true }
  }, [role, attempt])

  return { ...state, retry }
}
